import { combineReducers } from 'redux';

import * as actionTypes from 'modules/audits/actionTypes';
import { DETAILS_SOURCE } from 'modules/audits/constants';
import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const setTrue = () => true;
const setFalse = () => false;

// The audit-detail fetch flag (drives `isReady`). Scoped to DETAILS_SOURCE because fetchAudit is
// also fired by the share modal / drawer preview, which must not toggle the page's loading state.
const setFetching = value => (state, { meta = {} }) => (meta.source === DETAILS_SOURCE ? value : state);

const fetch = createReducer(false, {
  [actionTypes.FETCH_AUDIT_REQUEST]: setFetching(true),
  [actionTypes.FETCH_AUDIT_SUCCESS]: setFetching(false),
  [actionTypes.FETCH_AUDIT_FAILURE]: setFetching(false),
  [LOCATION_CHANGE]: setFetching(false),
});

// Creating and deleting an exploded-view marker share a single in-flight flag
// (both are "the marker list is mutating"), so they can't use a single `loading()` root.
const marker = createReducer(false, {
  [actionTypes.POST_MARKER_REQUEST]: setTrue,
  [actionTypes.POST_MARKER_SUCCESS]: setFalse,
  [actionTypes.POST_MARKER_FAILURE]: setFalse,
  [actionTypes.DELETE_MARKER_REQUEST]: setTrue,
  [actionTypes.DELETE_MARKER_SUCCESS]: setFalse,
  [actionTypes.DELETE_MARKER_FAILURE]: setFalse,
});

/**
 * All in-flight flags for the audit detail, grouped in one slice.
 * @typedef {{
 *   fetch: boolean,
 *   status: boolean,
 *   delete: boolean,
 *   start: boolean,
 *   printCustomerView: boolean,
 *   marker: boolean,
 *   updatingMarker: boolean,
 * }} AuditsUIDetailsLoading
 */

/** @type {import('redux').Reducer<AuditsUIDetailsLoading>} */
export default combineReducers({
  fetch,
  marker,
  start: loading(actionTypes.START_REQUEST),
  delete: loading(actionTypes.DELETE_REQUEST),
  status: loading(actionTypes.PATCH_STATUS_REQUEST),
  updatingMarker: loading(actionTypes.PATCH_MARKER_REQUEST),
  printCustomerView: loading(actionTypes.PRINT_CUSTOMER_VIEW),
});
